import { render, staticRenderFns } from "./NewCustomerTypeForm.vue?vue&type=template&id=1cce7bb5&"
import script from "./NewCustomerTypeForm.vue?vue&type=script&lang=js&"
export * from "./NewCustomerTypeForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports